import "./StaticPages.css";

export default function PrivacyPolicy() {
  return (
    <div className="static-page">
      <h1>Privacy Policy</h1>
      <p className="lead">Last updated: {new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" })}</p>

      <section>
        <h2>1. Information We Collect</h2>
        <p>When you use RinStore, we collect the following information:</p>
        <p><strong>Account Information:</strong> Your name, email address, mobile number, and encrypted password when you create an account.</p>
        <p><strong>Transaction Data:</strong> Order details, payment amounts, wallet transactions, and game account IDs you provide for top-ups.</p>
        <p><strong>Usage Data:</strong> IP address, browser type, device information, and pages visited for security and analytics purposes.</p>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <p>We use your information to process game top-up orders and deliver in-game items, manage your wallet balance and transaction history, send order confirmations, receipts, and important account notifications, prevent fraud and protect the security of our platform, and improve our services based on usage patterns.</p>
      </section>

      <section>
        <h2>3. Information Sharing</h2>
        <p>We do not sell, rent, or trade your personal information to third parties. We share data only with payment processors (Paytm, UPI providers) to complete transactions, game providers (SmileOne, Yokcash) to fulfill your orders, and law enforcement when required by law.</p>
      </section>

      <section>
        <h2>4. Data Security</h2>
        <p>We implement industry-standard security measures including password hashing with bcrypt, HMAC-signed payment tokens, rate limiting and brute-force protection, encrypted HTTPS connections, and NoSQL injection prevention.</p>
      </section>

      <section>
        <h2>5. Cookies</h2>
        <p>We use essential cookies and local storage tokens to keep you logged in and maintain your session. We do not use tracking cookies or third-party advertising cookies.</p>
      </section>

      <section>
        <h2>6. Your Rights</h2>
        <p>You can request access to your personal data, correction of inaccurate data, deletion of your account, or export of your transaction history by contacting us at <a href="mailto:support@rinstore.in">support@rinstore.in</a>.</p>
      </section>

      <section>
        <h2>7. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of any significant changes via email or a notice on our website.</p>
      </section>

      <section>
        <h2>8. Contact</h2>
        <p>For privacy-related questions, contact us at <a href="mailto:support@rinstore.in">support@rinstore.in</a>.</p>
      </section>
    </div>
  );
}